import useAnalytics from "@hooks/useAnalytics";
import useClientContext from "@hooks/useClientContext";
import useGame from "@hooks/useGame";
import { useEffect } from "react";
import { pxToRem } from "src/styles/styleUtils";
import { css } from "styled-components";
import PicksCompleteAd from "./ads/PicksCompleteAd";
import Modal, {
  ChaseContentContainer,
  ChaseHeaderContent,
  ChaseModalWrapper,
  playoffsModalCSS,
} from "./Modal";

function PicksCompleteModal() {
  const [{ openModal }] = useClientContext();
  const { data: game } = useGame();
  const { trackEvent } = useAnalytics();
  const current_round = game.state?.current_round ?? 1;
  const roundName = game?.rounds.find((r) => r.round_id === current_round).name;
  const shouldRenderModal = openModal.name === "PICKS_COMPLETE";

  useEffect(() => {
    if (shouldRenderModal) trackEvent("picks:completion_modal");
  }, [trackEvent, shouldRenderModal]);

  return shouldRenderModal ? (
    <Modal aria-label="Picks Complete Dialog" css={modalCSS}>
      <ChaseModalWrapper>
        <ChaseContentContainer>
          <ChaseHeaderContent>
            <h2>Congratulations!</h2>
            <p>Your predictions are in for the {roundName}</p>
          </ChaseHeaderContent>
          <PicksCompleteAd />
        </ChaseContentContainer>
      </ChaseModalWrapper>
    </Modal>
  ) : null;
}

export default PicksCompleteModal;

const modalCSS = css`
  ${playoffsModalCSS}

  .closeIcon {
    top: ${pxToRem(3)};
    right: ${pxToRem(2)};
    svg {
      width: ${pxToRem(14)};
    }
  }
`;
